import { render, staticRenderFns } from "./course_detail.vue?vue&type=template&id=56a9d612&scoped=true&"
import script from "./course_detail.vue?vue&type=script&lang=js&"
export * from "./course_detail.vue?vue&type=script&lang=js&"
import style0 from "./course_detail.vue?vue&type=style&index=0&id=56a9d612&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a9d612",
  null
  
)

export default component.exports